import color from "../../assets/css/colors";

export interface CircleColorPropsInterface {
    color: string;
}

export interface RadioButtonInterface {
    isPrimary: boolean;
}

export interface AddEstablishmentHeaderPageInterface {
    isActualOrPrevius: boolean;
}

export interface MonetaryInfoInterface {
    current_balance: string;
    account_balance: string;
}

export interface ICategoryMerchant extends ICategory{

}

export interface CepDetailInterface {
    cep: string,
    logradouro: string,
    complemento: string,
    bairro: string,
    localidade: string,
    uf: string,
}

export interface ICategory {
    id?: string;
    code?: string;
    category?: string;
    description?: string;
    resource?: string;
}

export type TCircleColorDefiner = typeof CircleColorDefiner[keyof typeof CircleColorDefiner]
export const CircleColorDefiner = {
    "succeeded": color.green,
    "pending": color.yellow,
    "failed": color.redDark
} as const